<style scoped lang="stylus">
.incident-banner
  position: relative
  width: 100vw
  left: 50%
  right: 50%
  margin-left: -50vw
  margin-right: -50vw
  background-color: #FFF4E5
  border: 1px solid #C87C00
  display: flex
  justify-content: space-between
  align-items: center
  padding: 12px 24px
  font-family: Arial, sans-serif
  font-size: 14px
  line-height: 20px
  flex-wrap: wrap

.incident-banner__center-wrapper
  display: flex
  justify-content: center
  flex: 1
  max-width: 900px
  margin: 0 auto
  width: 100%

.incident-banner__left
  display: flex
  align-items: center
  gap: 8px
  max-width: 100%

.incident-banner__text
  font-weight: 400
  color: #663C00
  margin: 0
  padding-left: 2px
  text-indent: -2px
  display: block
  line-height: 20px

.incident-banner__text strong
  font-weight: 700

.incident-banner__close
  font-size: 22px !important
  color: #C87C00 !important
  font-weight: 400
  cursor: pointer

.incident-banner__close-button
  background: none
  border: none
  padding: 0
  margin-left: 12px
  cursor: pointer
  display: flex
  align-items: center
  justify-content: center

@media (max-width: 768px)
  .incident-banner
    flex-wrap: wrap
    flex-direction: row
    align-items: center
    padding: 12px

  .incident-banner__center-wrapper
    flex: 1
    margin: 0
    max-width: 100%

  .incident-banner__left
    align-items: center
    gap: 8px
    text-align: left
    max-width: 100%

  .incident-banner__text
    max-width: 100%
    padding-left: 2px
    text-indent: -2px
    margin: 0

  .incident-banner__close
    font-size: 20px
</style>

<template>
  <div class="incident-banner" v-if="show">
    <div class="incident-banner__center-wrapper">
      <div class="incident-banner__left">
        <v-icon color="#C87C00" size="24"> mdi-alert-circle </v-icon>
        <p class="incident-banner__text">
          <strong>Canvas Incident:</strong>
          Canvas is experiencing issues due to an ongoing AWS incident. Learners will be unable to access class until
          Canvas has resolved the issue. Please do not process credit conversion for completed courses or enroll in any
          new Universal Learner Courses until the Canvas error has been resolved. Thank you for your patience.
        </p>
      </div>
    </div>
    <button @click="handleClose" class="incident-banner__close-button" aria-label="Close banner">
      <v-icon class="incident-banner__close">mdi-close</v-icon>
    </button>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  emits: ['close'],
  name: 'CanvasIncidentBanner',

  props: {
    show: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    handleClose() {
      this.$emit('close');
    }
  }
});
</script>
